export default [
  {
    key: '0',
    value: '-',
  },
  {
    key: '2w',
    value: '2 weeks',
  },
  {
    key: '1m',
    value: '1 month',
  },
  {
    key: '3m',
    value: '3 months',
  },
  {
    key: '1y',
    value: '1 year',
  },
]
